App.Modules.Panel.Admin = class AdminPanel extends App.Modules.Panel
{

	static get options()
	{
		return {};
	}

	get template()
	{
		// language=HTML
		return `
			<div id="panel" class="panel panel-left panel-cover">

				<div class="navbar"></div>

				<div class="list menu" pf="list"></div>
				<div class="list menu" pf="listAdmin"></div>				
		
			</div>
		`;
	}

	init()
	{
		super.init();


		this.listDemo = new PF.List({
			modelsConfig: {
				raw: [
					{
						id: '/main',
						name: 'Главная',
						icon: 'dashboard'
					},
					{
						id: '/overview',
						name: 'Обзор',
						icon: 'schedule'
					},
					{
						id: '/stats',
						name: 'Статистика',
						icon: 'pie_chart'
					},
					{
						id: '/comparison',
						name: 'Сравнение',
						icon: 'dns'
					},
					{
						id: '/stat-persons',
						name: 'Уникальные лица',
						icon: 'face'
					},
					{
						id: '/detections',
						name: 'Детекции',
						icon: 'rss_feed'
					},
					{
						id: '/polls-overview',
						name: 'Опросы',
						icon: 'help',
					},
					{
						id: '/presentation',
						name: 'Презентация',
						icon: 'personal_video',
					},
				]
			},
			dom: { element: this.dom.list },
			itemClass: Item,
			searchable: false
		});

		this.listAdmin = new PF.List({
			modelsConfig: {
				raw: [
					{
						id: '/stellas',
						name: 'Стелы',
						icon: 'dns'
					},
					{
						id: '/admin-panel/#!/main',
						name: 'Админ-панель',
						icon: 'settings',//'admin_panel_settings',
						external: true
					}
				]
			},
			dom: { element: this.dom.listAdmin },
			title: 'Оператор блок',
			itemClass: Item,
			searchable: false
		});
	}
}

class Item extends PF.List.Item
{
	get renderer()
	{
		//language=HTML
		return `
		  <li>
			  <a href="@{model.id}" class="item-link item-content panel-close" pf="linkPage">
				  <div class="item-media"><i class="material-icons">@{model.icon}</i></div>
				  <div class="item-inner">
					  <div class="item-title">@{model.name}</div>
				  </div>
			  </a>
		  </li>
		`;
	}

	onRender()
	{
		super.onRender();
		this.bindDom({ item: 'class:selected' }, { object: app, key: 'currentPage.path' }, (path) => this.model.id === path);
		if (this.model.external == true) {
			this.dom.linkPage.addClass('external');
		}
	}
}